import { Capacitor } from '@capacitor/core';
import { FRANKLIN_APP_URL } from '../../../external-urls';

// Solve's personal, credit builder and short-term loans are Franklin Credit loans, serviced in the
// Franklin app. On native, '_system' hands the URL to the device browser instead of navigating the
// Capacitor webview away from Solve.
export const openFranklinApp = () => {
  if (Capacitor.isNativePlatform()) {
    window.open(FRANKLIN_APP_URL, '_system');
  } else {
    window.location.assign(FRANKLIN_APP_URL);
  }
};
